import { Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';

import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import PageNotFound from 'PageNotFound';

import { Box, CircularProgress } from '@mui/material';
import { ProtectedRoute } from './ProtectedRoutes';

const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
const AuthForgetPassword = Loadable(lazy(() => import('views/pages/authentication/ForgetPassword')));
const Dashboard = Loadable(lazy(() => import('views/dashboard/Default')));
const PermissionNotAllowed = Loadable(lazy(() => import('PermissionNotAllowed')));
const NoPage = Loadable(lazy(() => import('views/NoPage')));
const GroupList = Loadable(lazy(() => import('views/group/group-list')));
const VisitorList = Loadable(lazy(() => import('views/visitor/visitor-list')));
const ChangePassword = Loadable(lazy(() => import('views/change-password')));
const InternalServerError = Loadable(lazy(() => import('views/pages/authentication/others/InternalServerError')));

const ThemeRoutes = () => {
    const token = localStorage.getItem('refresh_token');
    const changePasswordRequired = localStorage.getItem('change_password') === 'false'; // 🔑 false means must change

    return (
        <Suspense
            fallback={
                <Box
                    sx={{
                        height: '100vh',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <CircularProgress aria-label="Loading..." />
                </Box>
            }
        >
            <Routes>
                {/* Public Routes */}
                <Route path="/login" element={token ? <Navigate to="/" replace /> : <AuthLogin3 />} />
                <Route path="/forgot-password" element={<AuthForgetPassword />} />

                {/* Root Redirect */}
                <Route
                    path="/"
                    element={
                        token ? (
                            changePasswordRequired ? (
                                <Navigate to="/change-password" replace />
                            ) : (
                                <Navigate to="/dashboard" replace />
                            )
                        ) : (
                            <Navigate to="/login" replace />
                        )
                    }
                />

                {/* Protected Routes */}
                <Route
                    element={
                        <ProtectedRoute>
                            <MainLayout />
                        </ProtectedRoute>
                    }
                >
                    {changePasswordRequired ? (
                        // 🔒 Only allow /change-password
                        <>
                            <Route
                                path="/change-password"
                                element={
                                    <ProtectedRoute name="change-password">
                                        <ChangePassword />
                                    </ProtectedRoute>
                                }
                            />
                            {/* Anything else → redirect */}
                            <Route path="*" element={<Navigate to="/change-password" replace />} />
                        </>
                    ) : (
                        // ✅ Normal flow
                        <>
                            <Route
                                path="/dashboard"
                                element={
                                    <ProtectedRoute name="dashboard">
                                        <Dashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/change-password"
                                element={
                                    <ProtectedRoute name="change-password">
                                        <ChangePassword />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/visitor/visitor-list"
                                element={
                                    <ProtectedRoute name="visitorlist">
                                        <VisitorList />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/group/group-list"
                                element={
                                    <ProtectedRoute name="grouplist">
                                        <GroupList />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/internal-server-error"
                                element={
                                    <ProtectedRoute name="internalservererror">
                                        <InternalServerError />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/permissionnotallowed"
                                element={
                                    <ProtectedRoute name="permissionnotallowed">
                                        <PermissionNotAllowed />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/NoPage"
                                element={
                                    <ProtectedRoute name="NoPage">
                                        <NoPage />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="*"
                                element={
                                    <ProtectedRoute>
                                        <PageNotFound />
                                    </ProtectedRoute>
                                }
                            />
                        </>
                    )}
                </Route>
            </Routes>
        </Suspense>
    );
};

export default ThemeRoutes;
// import { Routes, Route, Navigate } from 'react-router-dom';
// import { lazy, Suspense } from 'react';

// import MainLayout from 'layout/MainLayout';
// import Loadable from 'ui-component/Loadable';
// import PageNotFound from 'PageNotFound';

// // import { useSelector } from 'react-redux';
// import { Box, CircularProgress } from '@mui/material';

// const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
// const AuthForgetPassword = Loadable(lazy(() => import('views/pages/authentication/ForgetPassword')));
// const Dashboard = Loadable(lazy(() => import('views/dashboard/Default')));
// const PermissionNotAllowed = Loadable(lazy(() => import('PermissionNotAllowed')));
// const NoPage = Loadable(lazy(() => import('views/NoPage')));
// const GroupList = Loadable(lazy(() => import('views/group/group-list')));
// const VisitorList = Loadable(lazy(() => import('views/visitor/visitor-list')));
// const ChangePassword = Loadable(lazy(() => import('views/change-password')));
// const InternalServerError = Loadable(lazy(() => import('views/pages/authentication/others/InternalServerError')));

// import { ProtectedRoute } from './ProtectedRoutes';

// const ThemeRoutes = () => {
//     return (
//         <Suspense
//             fallback={
//                 <Box
//                     sx={{
//                         height: '100vh',
//                         display: 'flex',
//                         justifyContent: 'center',
//                         alignItems: 'center'
//                     }}
//                 >
//                     <CircularProgress aria-label="Loading..." />
//                 </Box>
//             }
//         >
//             <Routes>
//                 <Route path="/login" element={localStorage.getItem('refresh_token') ? <Navigate to="/" replace /> : <AuthLogin3 />} />
//                 <Route path="/forgot-password" element={<AuthForgetPassword />} />

//                 <Route
//                     path="/"
//                     element={
//                         localStorage.getItem('change_password') == 'true' ? (
//                             <Navigate to="/dashboard" replace />
//                         ) : (
//                             <Navigate to="/change-password" replace />
//                         )
//                     }
//                 />

//                 <Route
//                     element={
//                         <ProtectedRoute>
//                             <MainLayout />
//                         </ProtectedRoute>
//                     }
//                 >
//                     <Route
//                         path="/dashboard"
//                         element={
//                             <ProtectedRoute name="dashboard">
//                                 <Dashboard />
//                             </ProtectedRoute>
//                         }
//                     />
//                     <Route
//                         path="/change-password"
//                         element={
//                             <ProtectedRoute name="change-password">
//                                 <ChangePassword />
//                             </ProtectedRoute>
//                         }
//                     />
//                     <Route
//                         path="/visitor/visitor-list"
//                         element={
//                             <ProtectedRoute name="visitorlist">
//                                 <VisitorList />
//                             </ProtectedRoute>
//                         }
//                     />
//                     <Route
//                         path="/group/group-list"
//                         element={
//                             <ProtectedRoute name="grouplist">
//                                 <GroupList />
//                             </ProtectedRoute>
//                         }
//                     />
//                     <Route
//                         path="/internal-server-error"
//                         element={
//                             <ProtectedRoute name="internalservererror">
//                                 <InternalServerError />
//                             </ProtectedRoute>
//                         }
//                     />
//                     <Route
//                         path="permissionnotallowed"
//                         element={
//                             <ProtectedRoute name="permissionnotallowed">
//                                 <PermissionNotAllowed />
//                             </ProtectedRoute>
//                         }
//                     />
//                     <Route
//                         path="NoPage"
//                         element={
//                             <ProtectedRoute name="NoPage">
//                                 <NoPage />
//                             </ProtectedRoute>
//                         }
//                     />
//                     <Route
//                         path="*"
//                         element={
//                             <ProtectedRoute>
//                                 <PageNotFound />
//                             </ProtectedRoute>
//                         }
//                     />
//                 </Route>
//             </Routes>
//         </Suspense>
//     );
// };

// export default ThemeRoutes;
